import { render, staticRenderFns } from "./benefit.vue?vue&type=template&id=8962cf34&scoped=true"
import script from "./benefit.vue?vue&type=script&lang=js"
export * from "./benefit.vue?vue&type=script&lang=js"
import style0 from "./benefit.vue?vue&type=style&index=0&id=8962cf34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8962cf34",
  null
  
)

export default component.exports